import { render, staticRenderFns } from "./SideBarSmall.vue?vue&type=template&id=4f4dd0e0&scoped=true&"
import script from "./SideBarSmall.vue?vue&type=script&lang=js&"
export * from "./SideBarSmall.vue?vue&type=script&lang=js&"
import style0 from "./SideBarSmall.vue?vue&type=style&index=0&id=4f4dd0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4dd0e0",
  null
  
)

export default component.exports